import {Component} from '@angular/core';
import { AppComponent } from 'src/app/app.component';

@Component({
	selector: 'app-page-not-found',
	templateUrl: './page-not-found.component.html',
	styles: `
		img {
			-webkit-user-drag: none;
			user-drag: none;
		}
	`
})

export class PageNotFoundComponent {
	constructor(
		public app: AppComponent,
	) {}

	getMenuTheme(): string {
		return this.app.menuTheme;
	}
}
